import React, { Component } from "react";

// Shared components and utilities
import { 
    OmniDropdownComponent, 
    OmniTooltipNextComponent, 
    OmniIconComponent, 
    AccordionComponent, 
    AlertMessagesService, 
    Utils,
    trackEvent,
    creativeMap
} from "../../../shared";

// Feature imports
import { CreateTaxonomyService } from "../";
import { PlacementDetailsTableService } from "../../placements";

export class CreateTaxonomyAccordionContentComponent extends Component {

    taxonomyNameArr = [];
    taxonomySchema = "";
    taxonomyDelimeterValue = '';
    taxonomiesDropdownOptions = [];
    taxonomyObjArray = [];
    cascadingMap = {};

    constructor(props) {
        super(props);

        this.state = {
            selectedTaxonomy: "",
            formData: {},
            taxonomyFields: [{field: 'select-taxonomy', renderElement: <div className="no-taxonomy-container" key="no-taxonomy-container">Select {this.props.isCreative ? 'Creative': 'Taxonomy'} template first to <br />display the related fields</div>}],
            disableCreateButton: true,
            requiredFields: [],
            taxonomyName: "",
            taxonomyData: [],
            allTaxonomyData: props.allTaxonomyData,
            defaultTaxonomyData: props?.state?.campaignObj?.defaultTaxonomyData,
            selectedTaxonomyObj: '',
            fields: [],
            createType: "Taxonomy",
            editCreativeName: false
        };

        this.updateTaxonomiesDropdownOptions();

    }

    /**
     * Lifecycle method that is invoked when the component is mounted.
     * It handles the logic to update the taxonomy dropdown based on the selected dropdown value.
     */
     componentDidMount = () => {
        if(this.props.isCreative){
            if(this.props.accordionData?.taxonomyTableData.length){
                this.populateCreativesDropdown(this.props);
            }
            this.setState({createType: "Creative"})
        }
        if(this.props?.selectedDD){
            this.handleTaxonomyDropdownClick({target:{ value: this.props?.selectedDD }});
        }
    }

    /**
     * Lifecycle method that is invoked when the component receives new props.
     * It handles the logic to update the taxonomy dropdown based on the selected dropdown value.
     * 
     * @param {Object} nextProps - The next props object received by the component.
     */
    componentDidUpdate = (prevProps) => {
        if (this.props?.selectedDD && (this.props?.selectedDD !== prevProps?.selectedDD)) {
            this.handleTaxonomyDropdownClick({target:{ value: this.props?.selectedDD }});
        }
        if(this.props.isCreative && this.props.accordionData?.taxonomyTableData?.length){
            if(this.props.accordionData?.taxonomyTableData[0] !== prevProps.accordionData?.taxonomyTableData[0]){
                this.populateCreativesDropdown(this.props);
            }
        }
    };

    /**
     * Updates the dropdown options for taxonomies.
     */
    updateTaxonomiesDropdownOptions = () => {
        const taxonomyNames = Object.keys(this.props?.allTaxonomyData);
        taxonomyNames.forEach(taxonomy => {
            if (this.props?.allTaxonomyData[taxonomy]?.name) {
                // Check for creative screen, if true then check for creative in name
                // and add to dropdown options else add all taxonomies
                if(this.props.isCreative){
                    let lowercaseName = taxonomy.toLowerCase();
                    if(lowercaseName.includes("creative")){
                        this.taxonomiesDropdownOptions.push({
                            value: creativeMap[taxonomy][0],
                            id:taxonomy
                        });
                    }
                } else {
                    this.taxonomiesDropdownOptions.push({
                        value: this.props?.allTaxonomyData[taxonomy]?.name,
                        id:taxonomy
                    });
                }
            }
        });
    }

    /**
     * This function creates form data for taxonomy creation
     * @function createTaxonomyFormData
     * @return {undefined} This function doesn't return anything. It just sets the state with form data, required fields, and taxonomy fields.
     */
    createTaxonomyFormData = () => {
        const mandatoryFields = [];
        const taxonomyObj = this.state?.selectedTaxonomyObj;
        let allCreativesFields = [...(taxonomyObj?.fields || [])];
        let newFormData = {...this.state.formData};
        if (taxonomyObj?.fields?.length) {
            taxonomyObj?.fields?.forEach((field, fieldIndex) => {
                    if (field?.field_type === 10) {
                        newFormData[field?.name] = "{TaxonomyValueID}";
                    } else {
                        newFormData[field?.name] = "";
                    }
    
                    if (field?.mandatory) {
                        mandatoryFields.push(field?.name);
                    }
    
                    if (fieldIndex + 1 === taxonomyObj?.fields?.length) {
                        this.setState({
                            formData: newFormData,
                            requiredFields: mandatoryFields,
                            fields: allCreativesFields
                        }, () => {
                            this.getTaxonomyFields(this.state.fields);
                        });
                    }
            })
        } else {
            this.setState({
                formData: newFormData,
                requiredFields: [],
                fields: allCreativesFields
            }, () => {
                this.getTaxonomyFields(this.state.fields);
            });
        }

    }

    /**
     * Handle the taxonomy dropdown click event
     * @function handleTaxonomyDropdownClick
     * @param {object} event - The click event object
     * @returns {undefined}
     */
    handleTaxonomyDropdownClick = (event) => {
        const value = Utils.getValue(event);
        if (value) {
            trackEvent(`Create ${this.props.isCreative ? 'Creative' : 'Taxonomy'} template selected`, { access_from: this.props.isCreative ? 'Create Creative Page' : 'Create Taxonomy Page', template: value, campaignId: this.props?.params?.campaignId });
            let formdataCopy = Object.assign({}, this.state.formData);
            if(this.props.isCreative){
                formdataCopy['creativeTemplate'] = event?.detail?.value;
            }
            this.setState({ selectedTaxonomy: value, selectedTaxonomyObj: this.state.allTaxonomyData[value], taxonomyName: "", formData: formdataCopy, disableCreateButton: true}, () => {
                let schema = CreateTaxonomyService.generateTaxonomySchema(this.state.selectedTaxonomyObj);
                this.taxonomyNameArr = schema.taxonomyNameDelimiterList;
                this.taxonomySchema = schema.taxonomySchema;
                this.createTaxonomyFormData();
            })
        }
    }

    /**
     * Handles the taxonomy dropdown click event
     * @function handleTaxonomyDropdownClick
     * @param {string} name - The name of the selected taxonomy
     * @param {Event} event - The event object that triggered the click event
     * @param {Object} selectedFieldTaxonomy - The selected taxonomy object
     * @returns {undefined}
     */
    onDataChange = (name, event, selectedFieldTaxonomy) => {
        const value = Utils.getValue(event);
        trackEvent(`Create ${this.props.isCreative ? 'Creative' : 'Taxonomy'} field - ${name} changed`, { access_from: this.props.isCreative ? 'Create Creative Page' : 'Create Taxonomy Page', field: name, value, campaignId: this.props?.params?.campaignId });
        const selectedFieldInTaxArray = this.taxonomyObjArray.filter(tax => tax.id === selectedFieldTaxonomy.id);

        if (selectedFieldInTaxArray.length) {
            selectedFieldInTaxArray[0].code = value;
            selectedFieldInTaxArray[0].delimiter = selectedFieldTaxonomy.delimiter_value;
        } else if(!selectedFieldTaxonomy.isDimensionField) {
            this.taxonomyObjArray.push({
                id: selectedFieldTaxonomy.id,
                code: value,
                delimiter: selectedFieldTaxonomy.delimiter_value
            });
        }

        event.preventDefault();

        // Check if this field is a free text field and doesn't allow spaces
        if (selectedFieldTaxonomy?.field_type === 2 && selectedFieldTaxonomy?.allowed_space === false && value && value.includes(' ')) {
            // Show error for space not allowed
            AlertMessagesService.showWarningToastMessage(`Spaces are not allowed in ${name}`);
            return; // Don't update state with invalid value
        }
        const formDataCopy = Object.assign({}, this.state.formData)
        formDataCopy[name] = value;
        let disableCreateButton = !this.state.requiredFields.every((field) => formDataCopy[field]);

        let taxonomyField = this.props.allTaxonomyData[this.state.selectedTaxonomy]
        let defaultTaxonomyData = structuredClone(this.props?.state?.campaignObj?.defaultTaxonomyData);
        let dimensionFields = defaultTaxonomyData?.fields?.filter( (field) => ['Dimensions', 'Dimension/Positions'].includes(field.name) || ['Dimensions', 'Dimension/Positions'].includes(field.alias) );
        let taxonomyFieldMap = taxonomyField?.fields?.map(obj => ({ ...obj }));
        let dimensionFieldsMap = dimensionFields?.map(obj => ({ ...obj, isDimensionField: true }));
        let formFields = taxonomyFieldMap.concat(dimensionFieldsMap || []);

        const fieldItem = selectedFieldTaxonomy.fielditems.find(fieldItem => fieldItem.code === value);
        let cascadedFieldIds = fieldItem?.childitems.map(child => parseInt(child.Id));
        // Apply cascading logic when selected field has child items to cascade
        if(cascadedFieldIds?.length){
            CreateTaxonomyService.applyCascading(fieldItem, formFields, name, cascadedFieldIds, formDataCopy, this.updateFieldsInState, this.cascadingMap, [...this.state.fields, ...dimensionFieldsMap]);
            disableCreateButton = !this.state.requiredFields.every((field) => formDataCopy[field]);
        } 
        // Restore original field items when cascading is cleared (no child items selected)
        else if(this.cascadingMap[name]){
            let currentFields = [...this.state.fields, ...dimensionFieldsMap];
            const index = currentFields.findIndex(field => field.name === this.cascadingMap[name].childField);
            if (index !== -1) {
                currentFields[index] = formFields[index];
            }
            delete this.cascadingMap[name];
            this.updateFieldsInState(currentFields, formDataCopy);
        } 
        // Normal field update without cascading
        else {
            this.updateFieldsInState(this.state.fields, formDataCopy);
        }
        this.setState({ disableCreateButton, formData: formDataCopy }, () => { this.createTaxonomyName() })
    }

    /**
     * Function to update the state with the updated fields
     * @function updateFieldsInState
     * @param {Array} formFields - The updated fields
     * @param {Object} formDataCopy - The copied form data
     * @returns {undefined}
    */ 
    updateFieldsInState = (formFields, formDataCopy) => {
        let disableCreateButton = !this.state.requiredFields.every((field) => formDataCopy[field] !== '');
        let creativeFields = formFields.filter(field => !field?.isDimensionField);
        let dimensionFields = formFields.filter(field => field?.isDimensionField && field?.name === 'Dimension/Positions');
        let updatedDefaultTaxonomyFields = this.state.defaultTaxonomyData?.fields?.map(field => {
            if(dimensionFields.length && field.name === 'Dimension/Positions'){
                return {...field, fielditems: dimensionFields[0]?.fielditems || []};
            } else {
                return field;
            }
        });
        this.setState((prevState) => ({ defaultTaxonomyData: { ...prevState.defaultTaxonomyData, fields: updatedDefaultTaxonomyFields }, fields: creativeFields, disableCreateButton }), () => {
            this.getTaxonomyFields(this.state.fields)
        });
    }

    /**
     * Creates a taxonomy name based on the values of the taxonomy name fields
     * @function createTaxonomyName
     * @returns {string} The taxonomy name created by joining the taxonomy name fields
    */
    createTaxonomyName = () => {
        const taxonomyName = this.taxonomyNameArr
                                                .filter(field => !field.hidden)
                                                .map(field => (this.state.formData[field.name] ? this.state.formData[field.name] : 'NU') + field.delimiter)
                                                .join('')
                                                .slice(0, -1);
        this.setState({ taxonomyName });
    }

    /**
     * @description A function to create taxonomy name fields based on the values of the taxonomy name fields
     * @function getTaxonomyFields
     * @param {Array} fields - The fields to create taxonomy name fields for
     * @returns {Array} An array of taxonomy name fields
     */
    getTaxonomyFields = (taxonomyFields = []) => {
        const content = [];
        if (this.state.selectedTaxonomy) {
            if (taxonomyFields?.length > 0) {
                taxonomyFields?.forEach((element, elementIndex) => {
                    if (element?.field_type === 1) {
                        const options = [];
                        let selectedOption = []
                        for (const fieldItem of element.fielditems) {
                            options.push({
                                id: fieldItem.code,
                                value: fieldItem.name
                            });
                            if (fieldItem.code?.trim().toLowerCase() === this.state.formData[element.name]?.trim().toLowerCase()) {
                                selectedOption = [{
                                    value: fieldItem.name,
                                    id: fieldItem.code
                                }]
                            }
                        }
                        content.push({
                            field: `${element.name}`, hidden: element?.hidden, id: element?.id, delimiter: element?.delimiter_value,
                            options: options,
                            type: 1,
                            renderElement: <div className={`input-container `} key={elementIndex}>
                                <label htmlFor={element.name + elementIndex} key={element.name + elementIndex + "-label"}>{element.mandatory && <>* </>} {element?.alias || element?.name}</label>
                                <OmniDropdownComponent
                                    typeahead
                                    searchindropdown
                                    id={element.name + elementIndex}
                                    key={element.name + elementIndex}
                                    options={options.length ? options : [{ label: 'test', value: 'test' }]}
                                    fieldid={element.id}
                                    fieldname={element.name}
                                    value={selectedOption}
                                    onDropdownChange={(event) => this.onDataChange(element.name, event, element)}
                                    placeholder='Select Value'
                                    hidefooter={true}
                                ></OmniDropdownComponent>
                            </div>
                        });
                    } else if (element?.field_type === 2) {
                        content.push({
                            field: `${element.name}`, hidden: element?.hidden, id: element?.id, delimiter: element?.delimiter_value,
                            type: 2,
                            renderElement: <div className={`input-container `} key={elementIndex}>
                                <label htmlFor={element.name + elementIndex} key={element.name + elementIndex + "-label"}>
                                    {element.mandatory && <>* </>}
                                    {element?.alias || element?.name}
                                    {element.allowed_space === false &&
                                        <span style={{ fontSize: "11px", color: "#666" }}> (Space not allowed)</span>
                                    }
                                </label>
                                <input
                                    id={element.name + elementIndex}
                                    fieldid={element.id}
                                    key={element.name + elementIndex}
                                    fieldname={element.name}
                                    value={this.state.formData[element.name]}
                                    onChange={(event) => this.onDataChange(element.name, event, element)}
                                    maxLength={element.character_limit}
                                    placeholder={element.name}
                                    disabled={element.disabled}
                                ></input>
                            </div>
                        });
                    } else if (element?.field_type === 10) {
                        content.push({
                            field: `${element.name}`, hidden: element?.hidden, id: element?.id, delimiter: element?.delimiter_value,
                            type: 2,
                            renderElement: <div className={`input-container `} key={elementIndex}>
                                <label htmlFor={element.name + elementIndex} key={element.name + elementIndex + "-label"}>{element?.alias || element?.name}</label>
                                <input
                                    id={element.name + elementIndex}
                                    fieldid={element.id}
                                    key={element.name + elementIndex}
                                    fieldname={element.name}
                                    placeholder="{TaxonomyValueID}"
                                    disabled
                                ></input>
                            </div>
                        });
                    }

                    if (elementIndex + 1 === taxonomyFields?.length) {
                        this.taxonomyDelimeterValue = element?.delimiter_value
                        this.setState({ taxonomyFields: content })
                    }
                });
                return content;
            } else {
                this.setState({ taxonomyFields: [{ field: 'no-taxonomy', renderElement: <div className="no-taxonomy-container" key="no-taxonomy-container">Selected {this.state.createType} is not available</div> }] })
            }
        } else {
            this.setState({
                taxonomyFields: [{ field: 'select-taxonomy', renderElement: <div className="no-taxonomy-container" key="no-taxonomy-container">Select {this.state.createType} template first to <br />display the related fields</div> }]
            })

        }
    }

    /**
     * Creates a new selected taxonomy based on the provided taxonomy name.
     * @function createSelectedTaxonomy
     * @param {string} taxonomyName - The name of the taxonomy to create.
     * @returns {void}
     */
    createSelectedTaxonomy = (taxonomyName, taxonomySchema, taxonomyFields) => {
        // First check if any spaces are in fields that don't allow them
        const fieldsWithoutSpaces = this.state.selectedTaxonomyObj?.fields?.filter(f =>
            !f.hidden && f.allowed_space === false && f.field_type === 2);

        // If we have fields that don't allow spaces, validate each part of the taxonomy name
        if (fieldsWithoutSpaces?.length > 0) {
            const taxonomyParts = taxonomyName.split(/:\||\|/);
            let invalidFieldIndex = -1;

            fieldsWithoutSpaces.forEach(field => {
                // Find index of this field in the fields list
                const fieldIndex = this.state.selectedTaxonomyObj.fields
                    .filter(f => !f.hidden)
                    .findIndex(f => f.name === field.name);

                if (fieldIndex >= 0 && taxonomyParts[fieldIndex]?.includes(' ')) {
                    invalidFieldIndex = fieldIndex;
                }
            });

            if (invalidFieldIndex >= 0) {
                const fieldName = this.state.selectedTaxonomyObj.fields
                    .filter(f => !f.hidden)[invalidFieldIndex]?.name || 'This field';

                AlertMessagesService.showWarningToastMessage(`${fieldName} cannot contain spaces`);
                trackEvent(`Create ${this.props.isCreative ? 'Creative' : 'Taxonomy'} failed validation`, { access_from: this.props.isCreative ? 'Create Creative Page' : 'Create Taxonomy Page', field: fieldName, reason: 'space-not-allowed', campaignId: this.props?.params?.campaignId });
                return;
            }
        }

        // Proceed with creation if validation passes
        if (this.props.isCreative) {
            trackEvent('Creative create requested', { access_from: 'Create Creative Page', name: taxonomyName, campaignId: this.props?.params?.campaignId });
            this.props.createSelectedCreative(taxonomyName, taxonomySchema, this.state.selectedTaxonomyObj, this.state.formData, this.state.editCreativeName, this.taxonomyObjArray);
        } else {
            trackEvent('Taxonomy create requested', { access_from: 'Create Taxonomy Page', name: taxonomyName, campaignId: this.props?.params?.campaignId });
            this.props.createSelectedTaxonomy(taxonomyName, taxonomySchema, taxonomyFields, this.state.selectedTaxonomyObj);
        }
    }

    /**
     * check selectedDD had in props or else check on selected taxonomy other wise it will return epmty array
     * @returns value of drop down in array
     */
    taxonomyDropdDownValue(){
        let value  = []
        if(this.props.isCreative){
            value = this.state.formData['creativeTemplate'] ? [this.state.formData['creativeTemplate']] : '';
        } else {
            if(this.props.selectedDD){
                value = [this.props.selectedDD]
            }else if(this.state.selectedTaxonomy){
                value = [this.state.selectedTaxonomy]
            }
        }
        return value;
    }

    /** CREATIVES HELPERS FUNCTIONS */

    populateCreativesDropdown = (props) => {
        let swappedCreativeMap = Utils.swapJson(creativeMap);
        let creativetaxonomyValue = swappedCreativeMap[props.accordionData?.taxonomyTableData[0]?.creative_type];
        this.handleTaxonomyDropdownClick({ target: { value: creativetaxonomyValue }, detail: { value: creativeMap[creativetaxonomyValue][0] } });
    }

    /**
     * Handles the supplier dropdown click event
     * @param {Event} event - The click event object
     * @param {Object} field - The field object containing the name of the field
     * @returns {void}
    */
    handleSupplierDropdownClick = (event, field) => {
        let formDataCopy = Object.assign({}, this.state.formData);
        let value = Utils.getValue(event);
        formDataCopy[field.name] = value;
        this.setState({ formData: formDataCopy }, () => {
            if(field.name === 'Supplier'){            
                this.supplierCascading(event.target.value);
            } else {
                let formDataCopy = Object.assign({}, this.state.formData);
                let indexOfSpace = event.detail.value.indexOf(" ");
                let restOfString = event.detail.value.slice(indexOfSpace + 1);
                formDataCopy['Site'] = restOfString;
                this.setState({ formData: formDataCopy });
            }
        });
    }

    /**
     * Handles the change event for the site input field
     * @param {Event} event - The change event object
     * @returns {void}
     */
    onSiteValueChange = (event) => {
        let formDataCopy = Object.assign({}, this.state.formData);
        formDataCopy['Site'] = event.target.value;
        this.setState({ formData: formDataCopy });
    }

    /**
     * Creates supplier fields based on the default taxonomy data
     * @function supplierFields
     * @returns {Array} An array of supplier fields
    */
    supplierFields = () => {
        let supplierFields = [];
        let dimensionFields = [];
        this.state?.defaultTaxonomyData?.fields?.forEach((field, fieldIndex) => {
            let isSupplierAndSupplierCode = ['Supplier', 'Supplier Code'].includes(field.alias) || ['Supplier', 'Supplier Code'].includes(field.name);
            let isSiteField = ['Site'].includes(field.alias) || ['Site'].includes(field.name);
            let isDimesionField = ['Dimensions', 'Dimension/Positions'].includes(field.alias) || ['Dimensions', 'Dimension/Positions'].includes(field.name);
            if(isSupplierAndSupplierCode || isDimesionField){
                let key = isSupplierAndSupplierCode ? "supplier_field_"+fieldIndex : "dimension_field_"+fieldIndex;
                let options = [];
                let selectedOption = [];
                for (const fieldItem of field.fielditems) {
                    options.push({
                      value: fieldItem.name,
                      id: fieldItem.code
                    });
                    if(fieldItem.code === this.state.formData[isDimesionField ? field.name + "_dimensionFields" : field.name]){
                        selectedOption = [{
                          value: fieldItem.name,
                          id: fieldItem.code
                        }]
                    }
                }
                let dropdownField = <div className="input-container" key={key}>
                        <label htmlFor="taxonomyDropdown">{field.name}</label>
                        <OmniDropdownComponent
                            typeahead
                            searchindropdown
                            virtualizedOptions
                            options={options}
                            value={selectedOption}
                            onDropdownChange={(event) => isDimesionField ? this.onDataChange(field.name + "_dimensionFields", event, {...field, isDimensionField: true}) : this.handleSupplierDropdownClick(event, field)}
                            id={field.name}
                            placeholder={`Choose ${field.name}`}
                            hidefooter={true}
                        ></OmniDropdownComponent>
                     </div>;
                if(isSupplierAndSupplierCode){
                    supplierFields.push(
                        dropdownField
                    )
                } else if(isDimesionField){
                    dimensionFields.push(
                        dropdownField
                    )
                }
            }
            if(isSiteField){ 
                let key = "site_field_"+fieldIndex;
                supplierFields.push(
                    <div className="input-container" key={key}>
                        <label htmlFor="taxonomyDropdown">{field.name}</label>
                        <input
                            value={this.state.formData[field.name]}
                            id={field.name}
                            onChange={(e) => this.onSiteValueChange(e)}
                            placeholder={`Enter ${field.name}`}
                        ></input>
                     </div>)
            }
        });
        return supplierFields.concat(dimensionFields);
    }

    /**
     * Handles the supplier cascading logic based on the selected value
     * @function supplierCascading
     * @param {string} selectedValue - The selected value from the supplier dropdown
     * @returns {void}
    */
    supplierCascading = (selectedValue) => {
        let defaultTaxonomyDataCopy =  JSON.parse(JSON.stringify(this.props?.state?.campaignObj?.defaultTaxonomyData));
        let supplierCodeData = defaultTaxonomyDataCopy?.fields?.find((field) => [field.name, field.alias].includes('Supplier Code'));
        let filterOptions = supplierCodeData?.fielditems;
        let vendorMappingsData = this.props?.state?.campaignObj?.vendorMappingsData;

        if (vendorMappingsData[selectedValue[0]?.value]) {
            filterOptions = vendorMappingsData[selectedValue[0]?.value];
        } else {
            let filterValues = supplierCodeData?.fielditems.filter((item) => item.name?.toLowerCase().includes(selectedValue[0]?.value?.toLowerCase()));
            if (filterValues.length > 0) {
                filterOptions = filterValues;
            }
        }

        const updatedFields = (defaultTaxonomyDataCopy && defaultTaxonomyDataCopy?.fields) && defaultTaxonomyDataCopy?.fields.map((obj) => {
          if ((selectedValue[0]?.value && filterOptions.length > 0) && [obj.name, obj.alias].includes('Supplier Code')) {
            return {...obj, fielditems: filterOptions};
          }
          return obj;
        })

        this.setState( prevState => ({defaultTaxonomyData:{...prevState.defaultTaxonomyData, fields: updatedFields}}));
    };

    /**
     * Handles the override creative logic
     * @function onOverrideCreative
     * @param {Event} event - The event triggered by the input change
     * @returns {void}
     */
    onOverrideCreative = (event) => {
        const value = Utils.getValue(event);
        this.setState({ taxonomyName: value, disableCreateButton: !value });
    }   

    /**
     * Handles the logic for overriding the creative name
     * @function overrideCreativeName
     * @returns {void}
     */
    overrideCreativeName = () => {
        this.setState({ editCreativeName: true });
    }

    /**
     * Cancels the override of the creative name and resets the button state
     * @function cancelOverride
     * @returns {void}
     */
    cancelOverride = () => {
        this.setState({ editCreativeName: false}, () => {
            this.populateFields();
        });
    }

    /**
     * Handles the population of fields based on the taxonomy name on cancel override
     * @function populateFields
     * @returns {void}
     */
    populateFields = () => {
        let editFormData = PlacementDetailsTableService.splitPlacementStringIntoSchemaObject(this.state.taxonomyName, this.taxonomySchema, this.state.selectedTaxonomyObj?.fields);
        let updatedFormData = {...this.state.formData, ...editFormData};
        this.setState({ formData: updatedFormData, disableCreateButton : !this.state.requiredFields.every((field) => updatedFormData[field]) }, () => {
            this.getTaxonomyFields(this.state.fields);
            this.createTaxonomyName();
        });
    }
    
    render() {
        return (
            <AccordionComponent accordion={{ header: `${this.state.createType} Options`, isOpen: true }}>
                <div className="create-taxonomy-container">
                    <div className="create-taxonomy-dropdown">
                        {this.props.isCreative && this.supplierFields()}
                        <div className="input-container">
                            <label htmlFor="taxonomyDropdown">{this.state.createType} Template</label>
                            <OmniDropdownComponent
                                typeahead
                                searchindropdown
                                options={this.taxonomiesDropdownOptions}
                                disabled={this.props.selectedDD || this.props.accordionData?.taxonomyTableData.length  ? true : null}
                                value={this.taxonomyDropdDownValue()}
                                onDropdownChange={(event) => this.handleTaxonomyDropdownClick(event)}
                                key="taxonomyDropdown"
                                id={this.props.selectedDD || this.state.selectedTaxonomy}
                                placeholder={`Choose ${this.state.createType} Template`}
                                hidefooter={true}
                            ></OmniDropdownComponent>
                        </div>
                        {this.props.isCreative && 
                        <div className="input-container">
                            <label htmlFor="taxonomyDropdown">Creative Name</label>
                            <input value={this.state.selectedTaxonomyObj?.name} disabled={true} id='creativeName' placeholder="Enter Creative Name"></input>
                        </div>}
                    </div>
                    <div className="taxonomy-input-container">
                        {this.state.selectedTaxonomyObj &&
                            <div className="taxonomy-name-preview-container">
                                <span>{this.state.createType} Name Details</span>
                                <label>{this.state.createType} Name (Preview)</label>
                                <div>
                                    <input disabled={!this.state.editCreativeName} onChange={() => this.onOverrideCreative(event)} value={this.state.taxonomyName} style={{width: "95%"}}/>
                                    {!this.state.editCreativeName && this.props.isCreative && 
                                        <OmniTooltipNextComponent>
                                            <button onClick={this.overrideCreativeName} slot="invoker" aria-haspopup="true" className="icon">
                                                <OmniIconComponent className="is-size-2 header-icon" icon-id="omni:interactive:edit" />
                                            </button>
                                            <div slot="content">Override Creative</div>
                                        </OmniTooltipNextComponent>
                                    }
                                    {this.state.editCreativeName && this.props.isCreative && 
                                        <OmniTooltipNextComponent>
                                            <button onClick={this.cancelOverride} slot="invoker" aria-haspopup="true" className="icon">
                                                <OmniIconComponent className="is-size-2 header-icon" icon-id="omni:interactive:reset" />
                                            </button>
                                            <div slot="content">Cancel Override</div>
                                        </OmniTooltipNextComponent>
                                    }
                                </div>
                            </div>
                        }
                        {this.state.taxonomyFields.map((field)=>{
                            return field.renderElement;
                        })}
                        {this.state.selectedTaxonomyObj &&
                            <div className="create-taxonomy-button">
                                <button onClick={(event) => this.createSelectedTaxonomy(this.state.taxonomyName, this.taxonomySchema, this.state.taxonomyFields)} className="create-taxonomy-button secondary" disabled={this.state.disableCreateButton} key="create-button">Create {this.state.createType} Name</button>
                            </div>
                        }
                    </div>
                </div>
            </AccordionComponent>
        );
    }
}